export default {
  sm: `
  Green data center
  originated from
  wisdom of our
  ancestors
  `,
  md: `
  Green data center
  originated from
  wisdom of
  our ancestors
  `,
  lg: `
  Green data center
  originated from wisdom of
  our ancestors
  `
};
